import React, { useState } from 'react';
import PropTypes from 'prop-types';
import './LookbookReportProducts.scss';
import _ from 'lodash';

import { getAllLookbookOrderItems, getLookbookItemOrderSiblingBreakdown, getLookbookRequests } from '../../../../Helpers/lookbook_helpers';
import LookbookReportProduct from './LookbookReportProduct';
import { lookbookReportItemFilter } from '../../../../Helpers/lookbook_helpers';

const LookbookReportProducts = props => {
  const { lookbook, analytics, startDate, endDate } = props;
  const lookbookRequests = getLookbookRequests(analytics, lookbook);
  const requests = lookbookRequests.filter(r => lookbookReportItemFilter(r, 'request', startDate, endDate));

  const [viewAllProducts, setViewAllProducts] = useState(false);

  const allLookbookOrderItems = getAllLookbookOrderItems(requests);
  const formattedOrderItems = lookbook.items
    .map(item => {
      const orderItems = allLookbookOrderItems.filter(orderItem => orderItem.LookbookItem_id === item.id);
      if (!orderItems.length) return null;

      const totalQuantity = _.sumBy(orderItems, 'quantity');
      const siblingBreakdown = getLookbookItemOrderSiblingBreakdown(item, requests);
      return { ...item, totalQuantity, orderItems, siblingBreakdown };
    })
    .filter(item => !!item)
    .sort((a, b) => b.totalQuantity - a.totalQuantity);

  return (
    <div className='lookbook-report-products-outer'>
      <div className='lookbook-report-products-inner'>
        {formattedOrderItems.map((product, i) => {
          // if not viewing all products only show one row (4 products)
          if (!viewAllProducts && i > 3) return null;
          return <LookbookReportProduct lookbook={lookbook} product={product} key={`lookbook-report-product-${product.id}`} />;
        })}

        {formattedOrderItems.length > 4 && (
          <div className='view-more-button' onClick={() => setViewAllProducts(!viewAllProducts)}>
            {viewAllProducts ? 'View Less' : 'View More'}
          </div>
        )}
      </div>
    </div>
  );
};

LookbookReportProducts.propTypes = {
  lookbook: PropTypes.object.isRequired,
  analytics: PropTypes.object.isRequired,
  startDate: PropTypes.string,
  endDate: PropTypes.string
};

export default LookbookReportProducts;
